export const SIM_LOCK_FACET = 'sim_lock'
export const SIM_LOCK_STATE_FACET = 'sim_lock_state'
export const COMPATIBLE_CARRIERS_FACET = 'compatible_carriers_facet'
